import { makeStyles } from '@material-ui/core';

export const getProposalPreviewDefaultCustomerProposalCommentStyles =
  makeStyles((theme) => ({
    comment: {
      fontWeight: theme.typography.fontWeightBold,
      textAlign: 'justify',
    },
  }));
